export function processingBox(content: TContent): TContent {
  return {
    ...content,
    attributes: { ...content.attributes, isWhiteBox: content.type === 'lh__whitebox', items: [] },
    children: content.children.concat(content.attributes.items?.content ?? []),
  };
}
